import moment from "moment";
import { momentDayMap, reverseMomentDayMap } from "../data/Constants";

export const getCapitalise = (str = "") => {
  try {
    let letter = str.charAt(0).toUpperCase();
    let part = str.substring(1, str.length);
    return letter + part + "";
  } catch (err) {
    console.log(err?.message);
  }
};

export function formatNumber(num, locale) {
  try {
    if (!isNaN(num)) {
      return Number(num).toLocaleString(locale ? locale : "en");
    }
    return 0;

  } catch (err) {
    console.log(err?.message);
  }
}

export function formatDate(date, format = "DD MMM, YYYY") {
  try {
    return isValidDate(date) ? moment(date).tz("Asia/Kolkata").format(format) : "-";
  } catch (err) {
    console.log(err?.message);
  }
}

export function isValidDate(date) {
  try {
    return moment(date).tz("Asia/Kolkata").isValid();
  } catch (err) {
    console.log(err?.message);
  }
}

export function getWeekDay({
  todaysDayAsNumber,
  todaysDayAsString,
  dayAsNumber,
  dayAsString,
}) {
  const today = moment().tz("Asia/Kolkata");
  const dayIndex = today.day();

  if (todaysDayAsNumber) {
    return dayIndex;
  }

  if (todaysDayAsString) {
    return momentDayMap[dayIndex];
  }

  if (dayAsNumber) {
    return reverseMomentDayMap[dayAsNumber];
  }

  if (dayAsString) {
    return momentDayMap[dayAsString];
  }
}

export function createNameInitial(name = "") {
  try {
    let parts = name;
    if (name.includes("_")) {
      parts = name.split("_");
    } else {
      parts = name.split(" ");
    }

    const partArr = parts.map((part) => getCapitalise(part.charAt(0)));
    const res = partArr.join("");

    return res;
  } catch (error) {
    console.log(error);
  }
}

export function normaliseString(str) {
  try {
    if (str && typeof str === "string") {
      return str?.replaceAll("_", " ");
    } else {
      return "N/A";
    }
  } catch (error) {
    console.log(error);
  }
}

/**
 * Function to used for safe parsing of data else returning undefined
 * @return parsed data.
 */
export const safeJsonParse = (data) => {
  /**Check if the input is already a JSON object*/
  try {
    if (typeof data === "object" && data !== null) {
      return data;
    }
    return JSON.parse(data);
  } catch (error) {
    try {
      let startsWith = data.startsWith("{");
      let endsWith = data.endsWith("}");
      if (startsWith && endsWith) {
        let sliced = data.slice(1, -1);
        data = "[" + sliced + "]";
        return JSON.parse(data);
      } else {
        return undefined;
      }
    } catch (err) {
      return undefined;
    }
  }
};
// let a = '{{"a":1,"b":2}}';
// let a = undefined ;
// let a = '';
// let a = '.';
// let a = null;
// let a = '[object object]';
// let a = {};
// let a = {"a":1,"b":2};
// let a = '{"a":1,"b":2}';
// let a = [];
// let a = [1,2,3];
// let a = [{"a":1,"b":2}];
// let a = '[{"a":1,"b":2}]';
// let a =  "{\"user_id\":\"4pKvbYFc7hC0v\",\"gym_id\":\"GLKdIYAWDS2Q8\",\"plan_id\":\"\",\"addon\":\"LnjlJARUgF2zQ\",\"alternate_number\":\"\",\"coupon\":\"\",\"event_id\":\"\",\"expire_date\":\"26-05-2024\",\"isWhatsapp\":true,\"is_full\":1,\"is_goal\":0,\"is_partial\":0,\"is_whatsapp\":true,\"order_id\":\"\",\"order_status\":\"\",\"partial_details\":{\"cash_amount\":0,\"online_amount\":0},\"price\":\"5999\",\"remark\":\"Test\",\"session_id\":\"KwUu8sQzx5WZk\",\"slot_id\":\"4fwWQXq3aAKCl\",\"start_date\":\"14-02-2024\",\"tax_amount\":\"915.10\",\"tax_percentage\":\"18\",\"trx_id\":\"\",\"trx_status\":\"\",\"type\":\"addon\",\"trainer_id\":\"c7Kc1MsGj9YeV\",\"start_time\":\"17:23\",\"end_time\":\"18:23\"}"// let a =  '["{\\"value\\":\\"10000\\",\\"percentage\\":\\"20\\",\\"from\\":\\"12\\",\\"to\\":\\"24\\"}"]'// let a = [[0]]console.log(safeJsonParse(a));// let length = (a.length)-1;
// let firstChar = a.charAt(0);
// let lastChar = a.charAt(a.length - 1);// if(firstChar === '{' && lastChar === '}'){
//   a = a.replace(a[0], '[');
//   a = a.replace(a[15], ']');
// }// console.log(a);
// console.log(JSON.parse(a));// console.log(a.slice(0,1));// console.log(a.slice(a.length,1));

export const getGymIDFromUser = (user) => {
  try {
    if (user?.uid) {
      // uid from user api is gym id
      return user.uid;
    }
    return null;
  } catch (error) {
    console.log(error);
  }
};

export function getHourDiff(start, end) {
  if (!start || !end) return 0;
  try {
    const [sh, sm = 0] = start.split(":").map(Number);
    const [eh, em = 0] = end.split(":").map(Number);
    let diff = eh + em / 60 - (sh + sm / 60);
    if (diff < 0) diff += 24;
    return Math.round(diff * 10) / 10;
  } catch {
    return 0;
  }
}

